import React, { useRef } from 'react';
import Seo, { SITE } from '../Seo/Seo';
import MissionIntro from './MissionIntro';
import VocalTrainingDetails from './VocalTrainingDetails';
import FamilyStory from './FamilyStory';

const AboutUs = () => {
	return (
		<div
			style={{
				scrollSnapType: 'y mandatory',
				overflowY: 'scroll',
				height: '100vh',
			}}>
			<Seo
				title='About Color Your Voice | Burnsville, MN'
				description='Color Your Voice is a youth voice and performing arts studio in Burnsville, MN — working teaching artists helping kids and teens build confidence through singing and performance.'
				canonical={`${SITE}/about`}
			/>
			<MissionIntro />
			<VocalTrainingDetails />
			<FamilyStory />
		</div>
	);
};

export default AboutUs;
